import { createRoot } from "react-dom/client";
import { initSentry } from "./lib/sentry";
import { initPostHog } from "./lib/posthog";
import "./i18n/config";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry before React renders so early errors are captured.
initSentry();

// Defer PostHog until the main thread is idle so its surveys.js / config.js
// fetches don't compete with LCP assets on the landing page. 2026-04-18.
if (typeof window !== "undefined") {
  const startPostHog = () => initPostHog();
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(startPostHog, { timeout: 3000 });
  } else {
    setTimeout(startPostHog, 2000);
  }
}

// Clean up old Supabase project token (one-time migration)
try {
  const oldKey = 'sb-pwsinghvwcepdvqqmnvj-auth-token';
  if (localStorage.getItem(oldKey)) {
    localStorage.removeItem(oldKey);
  }
} catch {}

createRoot(document.getElementById("root")!).render(<App />);
